import { useEffect } from 'react';
import { classes } from '../../Helpers';
import styles from './MasterDetail.module.scss';

function MasterDetail(props) {
	const {
		selectionList = [],
		renderDetailBody,
		selectorHead,
		selectedNav,
		setSelectedNav,
		showHeader = true,
		renderNavItem = null,
		search = '',
		setSearch = () => { },
	} = props;
	// const [selectedNav, setSelectedNav] = useState(null);

	useEffect(() => {
		if (!selectionList?.length > 0) {
			setSelectedNav(null);
		}
	}, [selectionList]);

	return (
		<div className={styles.root}>
			<div className={styles.lhs}>
				{showHeader && (
					<p className={styles.header}>
						Select
						{' '}
						{selectorHead}
					</p>
				)}
				<div className='flex justify-center w-full mt-2'>
					<input
						className='border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
						type='text'
						placeholder='Search'
						value={search}
						onChange={(e) => {
							setSearch(e.target.value);
						}}
					/>
				</div>
				{selectionList?.map((ele) => {
					const isActive = selectedNav?.id === ele?.id;
					return (
						<div
							className={classes(
								styles.selector,
								isActive ? styles.active : ''
							)}
							onClick={() => {
								setSelectedNav(ele);
							}}
						>
							{renderNavItem ? renderNavItem(ele) : ele?.name}
						</div>
					);
				})}
			</div>
			<div className={styles.rhs}>{renderDetailBody(selectedNav)}</div>
		</div>
	);
}

export default MasterDetail;
